import React, { ReactNode } from "react";
import { Tabs, Tab, Col, Container, Row } from "react-bootstrap";

import LOGIN_IMAGE from "assets/login-page.jpg";
import { Otp } from "./otp";
import { UsernamePasswordForm } from "./username-password";
import styles from "./login.module.scss";
import { Link } from "react-router-dom";
export const Login = ({ children }: { children: ReactNode }) => {
  return (
    <div className={styles.login_container}>
      <Container>
        <Row className={styles.login_form_container}>
          <Col md="6" sm="12" className={styles.form_container}>
            <h1 className="text-center">به پولبان خوش آمدید</h1>
            <label className="my-2 fs-medium">
              برای استفاده از خدمات پولبان وارد حساب کاربری خود شوید.
              <br />
              در صورت نداشتن حساب کاربری <Link to={"#"}>ثبت ‌‌نام</Link> کنید.
            </label>
            <Tabs
              defaultActiveKey="username and password"
              id="login-form"
              className="my-3 mb-1"
            >
              <Tab
                eventKey="username and password"
                title="نام کاربری و رمز عبور"
              >
                <UsernamePasswordForm />
              </Tab>
              <Tab className="w-100" eventKey="otp" title="رمز یکبار مصرف">
                <Otp />
              </Tab>
            </Tabs>
          </Col>
          <Col md="6" className="p-0">
            <img
              className={styles.image_container}
              src={LOGIN_IMAGE}
              alt="LOGIN_IMAGE"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};
